import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from '../error-handler.service';
import { AnimationsService } from '../animations.service';
import { environment } from '../../../environments/environment';
import { API } from '../api';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CertificadoProvaService {

constructor(
  private http: HttpClient,
  private animationsService: AnimationsService,
  private errorHandlerService: ErrorHandlerService,
  private authService: AuthService,
  ) { }

  cadastrar(data): Observable<any> {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post(`${environment.baseUrl}${API.certificadoProva.cadastrar}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar os dados', []))
      );
  }

  buscarPorMatriculaId(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.certificadoProva.buscarPorMatriculaId}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados', []))
      );
  }

  buscarSolicitacaoAtual(id): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    return this.http.get(`${environment.baseUrl}${API.certificadoProva.buscarSolicitacaoAtual}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Falha ao obter dados', []))
      );
  }
}
